import { Selectable } from '../../protocols/selectable';

export class DropDownItem implements Selectable {
  public title: string;
  public value: any;
  public disabled: boolean = false;
  // Optional category header this item belongs under. Items sharing the same group are rendered
  // together beneath a non-interactive header (desktop) / <optgroup> (mobile). Null = ungrouped.
  public group: string | null = null;

  constructor(title: string, value: any, disabled: boolean = false, group: string | null = null) {
    this.title = title;
    this.value = value;
    this.disabled = disabled;
    this.group = group;
  }

  getSelectionTitle(): string {
    return this.title;
  }

  getSelectionValue(): any {
    return this.value;
  }

  getSelectionUniqueIdentifier(): any {
    return this.value;
  }

  getSelectionIsDisabled(): boolean {
    return this.disabled;
  }
}
